import { Directive, inject } from '@angular/core';

import { InlineDialog } from '@shared/components/inline-dialog/inline-dialog.component';

@Directive({
  selector: '[zefSidenavDiscardDialog]',
  standalone: false,
})
export class SidenavDiscardDialog {
  readonly dialog = inject(InlineDialog, { self: true });
}
